const groupConfig = {
  name: 'Group',
  endpoint: '/internal_admin/admin_kit/groups',
  modelKey: 'rbac_group',

  columns: [
    { name: 'name', title: 'Name', type: 'link' },
    { name: 'account_name', title: 'Account' },
    { name: 'description', title: 'Description' },
    { name: 'created_at', title: 'Created' },
  ],

  filters: [
    { name: 'q[name_cont]', label: 'Name' },
    { name: 'q[description_cont]', label: 'Description' },
  ],

  attributes: [
    { name: 'id', label: 'ID' },
    { name: 'name', label: 'Name' },
    { name: 'description', label: 'Description' },
    { name: 'account_name', label: 'Account' },
    { name: 'created_by_name', label: 'Created By' },
    { name: 'created_at', label: 'Created At' },
    { name: 'updated_at', label: 'Updated At' },
  ],

  panels: [
    {
      title: 'Members',
      endpoint: (record) =>
        `/internal_admin/admin_kit/groups/${record.id}/members`,
      columns: [{ name: 'user_email', title: 'User' }],
      add: {
        endpoint: (record) =>
          `/internal_admin/admin_kit/groups/${record.id}/add_member`,
        paramKey: 'group_membership',
        field: {
          name: 'user_id',
          label: 'User',
          type: 'typeahead',
          searchEndpoint: '/internal_admin/admin_kit/groups/user_search',
        },
      },
      remove: {
        endpoint: (record, row) =>
          `/internal_admin/admin_kit/groups/${record.id}/remove_member/${row.id}`,
      },
    },
    {
      title: 'Roles',
      endpoint: (record) =>
        `/internal_admin/admin_kit/groups/${record.id}/group_roles`,
      columns: [{ name: 'role_name', title: 'Role' }],
      add: {
        endpoint: (record) =>
          `/internal_admin/admin_kit/groups/${record.id}/add_role`,
        paramKey: 'group_role_assignment',
        field: {
          name: 'role_id',
          label: 'Role',
          type: 'typeahead',
          searchEndpoint: '/internal_admin/admin_kit/groups/role_search',
        },
      },
      remove: {
        endpoint: (record, row) =>
          `/internal_admin/admin_kit/groups/${record.id}/remove_role/${row.id}`,
      },
    },
  ],

  form: {
    fields: [
      { name: 'name', label: 'Name', type: 'text', required: true },
      { name: 'description', label: 'Description', type: 'text' },
      {
        name: 'account_id',
        label: 'Account',
        type: 'typeahead',
        searchEndpoint: '/internal_admin/admin_kit/groups/account_search',
        displayField: 'account_name',
        required: true,
      },
    ],
  },
};

export default groupConfig;
